export default __webpack_public_path__ + "static/media/template2.34bef955.svg";